/**
 * 微信配置页面路径
 */

export default {
  namespaced: true,

  state: () => ({
    wxConfUrl: ''
  }),

  mutations: {
    setWxConfUrl (state, url) {
      state.wxConfUrl = url
    }
  }
}
